export default {
  loginMonitorApi: {
    getLawyerStatus: 'api/loginMonitor/getLawyerStatus',
    getOperationTypeLog: 'api/loginMonitor/getOperationTypeLog',
    exportOperationTypeLog: 'api/logging/loginSign/exportUserSignLog',
    getUserLog: 'api/loginMonitor/getUserLog'
  }
}
